export const toastNotification = ({ title, description, image }) => {
  new Notification(title, {
    body: description,
    icon: image,
  });
};

export const sendNativeNotification = ({ title, body, image }) => {
  // Implement your native notification logic
  alert("Hello");
  new Notification(title, {
    body: body,
    icon: image,
  });
};
